import { render } from "./SchoolSetting.vue?vue&type=template&id=742a6eaf&ts=true"
import script from "./SchoolSetting.vue?vue&type=script&lang=ts"
export * from "./SchoolSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__